module.exports = __webpack_public_path__ + "static/media/lepes10.6e69ec53.png";